module.exports = __webpack_public_path__ + "static/media/sabrina-pantal.7bc59b8b.md";